/** Firebase Storage paths for punch selfie / attendance images (Flutter mobile app). */

export const ATTENDANCE_IMAGE_ROOT = "attendance-images";

/** Default company folder in Storage (Flutter uploads to `company/default/…`). */
export const ATTENDANCE_IMAGE_COMPANY_ID = "default";

/**
 * Map Firestore CompanyId to Storage company folder.
 * Payroll docs often use CompanyId `1`; mobile app stores under `default`.
 */
export function resolveStorageCompanyId(employeeCompanyId) {
  const s = String(employeeCompanyId ?? "").trim().toLowerCase();
  if (!s || s === "1") return ATTENDANCE_IMAGE_COMPANY_ID;
  if (s === "default") return ATTENDANCE_IMAGE_COMPANY_ID;
  return String(employeeCompanyId).trim();
}

/**
 * Attendance branch label → storage branch folder id.
 * Override per employee when BranchId exists on the employee doc.
 */
export const ATTENDANCE_BRANCH_STORAGE_IDS = {
  "Main Shop": "1",
  Spareway: "2",
  "Branch 3": "3",
};

export function attendanceStorageBranchId(branchLabel, employeeBranchId) {
  const fromEmp = String(employeeBranchId ?? "").trim();
  if (fromEmp) return fromEmp;
  return ATTENDANCE_BRANCH_STORAGE_IDS[branchLabel] || "1";
}

/** `yyyy-mm-dd` → storage path segments YYYY/MM/DD */
export function ymdToStorageSegments(ymd) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(ymd || "").trim());
  if (!m) return null;
  return { year: m[1], month: m[2], day: m[3] };
}

export function buildAttendanceImageDayPrefix({ companyId, branchId, ymd }) {
  const seg = ymdToStorageSegments(ymd);
  if (!seg) return "";
  return `${ATTENDANCE_IMAGE_ROOT}/company/${companyId}/branch/${branchId}/${seg.year}/${seg.month}/${seg.day}`;
}

export function buildAttendanceImageEmployeePrefix({ companyId, branchId, ymd, employeeId }) {
  const day = buildAttendanceImageDayPrefix({ companyId, branchId, ymd });
  const eid = String(employeeId || "").trim();
  if (!day || !eid) return "";
  return `${day}/${eid}`;
}

/** Parse `143052.jpg` → `14:30:52` */
export function parsePunchTimeFromImageFilename(filename) {
  const base = String(filename || "").replace(/\.[^.]+$/, "");
  const m = /^(\d{2})(\d{2})(\d{2})$/.exec(base);
  if (!m) return null;
  return `${m[1]}:${m[2]}:${m[3]}`;
}
